import { Component } from '@angular/core';
import { ReferenceDataConstants } from '../../../../../lib/constants/reference-data-constants';
import { ApplicantIncomeFromOutsideUK } from '../../../models/applicant-income-from-outside-uk.model';
import { BaseApplicantComponent } from '../base-applicant.component';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-form-income-outside-uk',
  templateUrl: './form-income-outside-uk.component.html',
  styleUrls: ['./form-income-outside-uk.component.scss']
})
export class FormIncomeOutsideUkComponent extends BaseApplicantComponent {
  referenceDataConstants = ReferenceDataConstants;

  public selectedCountryCode: string;

  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }

  removeIncome(income): void {
    if (
      this.applicant.ApplicantIncomeFromOutsideUKs &&
      this.applicant.ApplicantIncomeFromOutsideUKs.indexOf(income) !== -1
    ) {
      this.applicant.ApplicantIncomeFromOutsideUKs.splice(
        this.applicant.ApplicantIncomeFromOutsideUKs.indexOf(income),
        1
      );
    }
  }

  addNewIncome(): void {
    if (!this.applicant.ApplicantIncomeFromOutsideUKs) {
      this.applicant.ApplicantIncomeFromOutsideUKs = [];
    }

    const income = new ApplicantIncomeFromOutsideUK();
    income.IncomeCountryISOCode = this.selectedCountryCode;
    this.applicant.ApplicantIncomeFromOutsideUKs.push(income);
    this.selectedCountryCode = undefined;
  }

  canAddNewIncome(): boolean {
    let canAddIncome: boolean;
    canAddIncome = !this.selectedCountryCode
      ? false
      : this.applicant.ApplicantIncomeFromOutsideUKs
      ? this.areIncomePercentagesCompleted()
      : true;

    return canAddIncome;
  }

  private areIncomePercentagesCompleted(): boolean {
    let canAddIncome: boolean;
    if (this.applicant.ApplicantIncomeFromOutsideUKs.length === 0) {
      canAddIncome = true;
    }
    for (const income of this.applicant.ApplicantIncomeFromOutsideUKs) {
      canAddIncome = income.IncomePercentage ? true : false;
    }

    return canAddIncome;
  }
}
